// extracted by mini-css-extract-plugin
export var childrenContainer = "_4w-0";
export var virtualScrollArea = "_4w-1";